import React, { useCallback, useContext, useEffect, useState } from 'react';
import css from './InputRow.module.css';
import TextArea from 'antd/es/input/TextArea';
import classNames from 'classnames';
import MaterialInput, { MaterialInputProps } from '../../MaterialInput';
import MaterialInputArea from '../../MaterialInputArea';
import { FormItemProps } from 'antd';

type FormInputProps = MaterialInputProps & FormItemProps & {};
const FormInput = ({ className, disabled = false, ref, getValueProps, ...rest }: FormInputProps) => {
  return (
    <MaterialInput
      {...rest}
      disabled={disabled}
      contentEditable={false}
      value={rest.value || ''}
      className={className}
    />
  );
};

export default FormInput;
